<template>
  <div class="row">
    <RoeHeader class="column left"></RoeHeader>
    <div class="column right">
      <router-view />
    </div>
  </div>
</template>

<style scoped>
.column {
  float: left;
}

.left {
  width: 15%;
}

.right {
  width: 80%;
  background-color: white;
  min-height: 420px;
  border-left-color: #ababab;
  border-left-style: solid;
  padding-left: 40px;
}
</style>

<script>
import RoeHeader from "./MainHeader";
export default {
  name: "RoeMainLayout",
  components: { RoeHeader }
};
</script>
